import { Mic, Brain, Target, MessageSquare, Shield } from 'lucide-react';
import { Tag } from '../ui/atoms/Tag';

const TIPS = [
  { icon: Mic, text: 'Speak clearly and at a natural pace' },
  { icon: Brain, text: 'Use specific examples from your experience' },
  { icon: Target, text: 'Focus on outcomes and results you achieved' },
  { icon: MessageSquare, text: 'Ask clarifying questions when needed' },
  { icon: Shield, text: 'Stay confident when handling objections' },
];

const SKILLS = [
  'Discovery',
  'Objection Handling',
  'Closing Technique',
  'Rapport Building',
  'Persuasion',
];

export function InterviewActiveCard() {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 h-full flex flex-col overflow-hidden">
      <div className="p-5 flex flex-col flex-1">
        <h2 className="font-heading text-dark-invirtus text-base font-bold mb-1">
          Interview in Progress
        </h2>
        <p className="font-body text-gray-400 text-[11px] mb-5">
          The AI is evaluating your sales skills
        </p>

        {/* Skills being assessed */}
        <div className="mb-5">
          <p className="font-heading text-dark-invirtus text-[10px] font-bold uppercase tracking-wider mb-2">
            Assessing
          </p>
          <div className="flex flex-wrap gap-1.5">
            {SKILLS.map(skill => (
              <Tag key={skill} intent="primary" variant="subtle">
                {skill}
              </Tag>
            ))}
          </div>
        </div>

        {/* Tips */}
        <div className="flex-1">
          <p className="font-heading text-dark-invirtus text-[10px] font-bold uppercase tracking-wider mb-3">
            Tips
          </p>
          <div className="space-y-2.5">
            {TIPS.map(({ icon: Icon, text }) => (
              <div key={text} className="flex items-start gap-2.5">
                <Icon className="w-3.5 h-3.5 text-gray-400 shrink-0 mt-0.5" />
                <p className="font-body text-gray-500 text-[11px] leading-snug">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
